/*global define*/
define([
        "./en/labels",
        "./fr/labels"
    ],
    function (i18nEn, i18nFr) {

        'use strict';

        return {

            en: i18nEn,
            fr: i18nFr
        }
    });


//////////////////
// WEBPACK FOOTER
// ./src/nls/labels.js
// module id = 11
// module chunks = 0